/* eslint-disable no-unused-vars */
export enum Availability {
	Disponivel = 'Disponível',
	Indisponivel = 'Indisponível',
}

export enum Status {
	Folga = 'Folga',
	Trabalhando = 'Trabalhando',
	Ferias = 'Férias',
	Afastado = 'Afastado',
	EmTreinamento = 'Em treinamento',
	SemStatus = 'N/A',
}

export enum Realization {
	Formacao = 'Formação',
	Reciclagem = 'Reciclagem',
}

export enum RedmineStatus {
	SolicitacaoAprovada = 'SOLICITAÇÃO APROVADA',
	SolicitacaoEmAnalise = 'SOLICITAÇÃO EM ANÁLISE',
	SolicitacaoRejeitada = 'SOLICITAÇÃO REJEITADA',
	SolicitacaoCancelada = 'SOLICITAÇÃO CANCELADA',
	SolicitacaoExpirada = 'SOLICITAÇÃO EXPIRADA',
	EmProcessamento = 'EM PROCESSAMENTO',
	ErroNaAtribuicao = 'ERRO NA ATRIBUIÇÃO',
	FalhaNoProcessamento = 'FALHA NO PROCESSAMENTO',
}

export const RedmineStatusLabels = [
	{ label: 'Aprovada', value: RedmineStatus.SolicitacaoAprovada },
	{ label: 'Pendente', value: RedmineStatus.SolicitacaoEmAnalise },
	{ label: 'Rejeitada', value: RedmineStatus.SolicitacaoRejeitada },
	{ label: 'Cancelada', value: RedmineStatus.SolicitacaoCancelada },
	{ label: 'Expirada', value: RedmineStatus.SolicitacaoExpirada },
	{ label: 'Erro na atribuição', value: RedmineStatus.ErroNaAtribuicao },
];

export const ExternalLocation = 'EXTERNO';
